export default (function () {
  return {
    breakpoint(el) {
      const element = el === null || el === undefined ? document.getElementsByTagName('body')[0] : el;

      if (window.getComputedStyle) {
        return window.getComputedStyle(element, ':before').getPropertyValue('content').replace(/'|"/g, '');
      }

      return false;
    },
    setAttributes(el, attrs) {
      const setAttr = function (element) {
        Object.keys(attrs).forEach((key) => {
          element.setAttribute(key, attrs[key]);
        });
      };

      if (this.isNodeList(el)) {
        this.forEach(el, (i, val) => {
          setAttr(val);
        });
      } else {
        setAttr(el);
      }
    },
    removeAttribute(el, attr) {
      const remAttr = function (element) {
        element.removeAttribute(attr);
      };

      if (this.isNodeList(el)) {
        this.forEach(el, (i, val) => {
          remAttr(val);
        });
      } else {
        remAttr(el);
      }
    },
    triggerEvent(el, type) {
      if ('createEvent' in document) {
        // modern browsers, IE9+
        const e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
      } else {
        // IE 8
        const e = document.createEventObject();
        e.eventType = type;
        el.fireEvent(`on${e.eventType}`, e);
      }
    },
    // helper for enabling IE 8 event bindings
    addEvent(el, type, handler) {
      const addEvent = function (event) {
        if (el.attachEvent) el.attachEvent(`on${type}`, handler);
        else el.addEventListener(type, handler);
      };
      if (type.indexOf(' ') > 0) {
        const events = type.split(' ');
        for (let i = 0; i < events.length; i++) {
          addEvent(events[i]);
        }
      } else {
        addEvent(type);
      }
    },
    hasClass(el, className) {
      if (el === null) return false;
      return el.classList ? el.classList.contains(className) : new RegExp(`\\b${className}\\b`).test(el.className);
    },
    addClass(el, sClass) {
      const addClass = function (element) {
        const classArray = sClass.split(' ');
        for (let i = 0; i < classArray.length; i++) {
          if (element.classList) element.classList.add(classArray[i]);
          else if (!this.hasClass(el, classArray[i])) element.className += ` ${classArray[i]}`;
        }
      };
      if (this.isNodeList(el)) {
        this.forEach(el, (i, val) => {
          addClass(val);
        });
      } else {
        addClass(el);
      }
    },
    removeClass(el, sClass) {
      const removeClass = function (element) {
        const classArray = sClass.split(' ');
        for (let i = 0; i < classArray.length; i++) {
          if (element.classList) element.classList.remove(classArray[i]);
          else element.className = element.className.replace(new RegExp(`\\b${classArray[i]}\\b`, 'g'), '');
        }
      };

      if (this.isNodeList(el)) {
        this.forEach(el, (i, val) => {
          removeClass(val);
        });
      } else {
        removeClass(el);
      }
    },
    toggleClass(el, sClass) {
      const toggleClass = function (element) {
        const classArray = sClass.split(' ');
        for (let i = 0; i < classArray.length; i++) {
          if (element.classList) {
            element.classList.toggle(classArray[i]);
          } else {
            const classes = element.className.split(' ');
            const existingIndex = classes.indexOf(classArray[i]);

            if (existingIndex >= 0) {
              classes.splice(existingIndex, 1);
            } else {
              classes.push(classArray[i]);
            }
            element.className = classes.join(' ');
          }
        }
      };

      if (this.isNodeList(el)) {
        this.forEach(el, (i, val) => {
          toggleClass(val);
        });
      } else {
        toggleClass(el);
      }
    },
    toggle(el) {
      this.toggleClass(el, 'is-hidden');
    },
    offset(el) {
      const rect = el.getBoundingClientRect();
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    },
    forEach(array, callback, scope) {
      for (let i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]); // passes back stuff we need
      }
    },
    isNodeList(nodes) {
      const stringRepr = Object.prototype.toString.call(nodes);
      const regex = /^\[object (HTMLCollection|NodeList|Object)\]$/;

      return (
        typeof nodes === 'object' &&
        regex.test(stringRepr) &&
        typeof nodes.length === 'number' &&
        (nodes.length === 0 || (typeof nodes[0] === 'object' && nodes[0].nodeType > 0))
      );
    },
    indexInParent(node) {
      const children = node.parentNode.childNodes;
      let num = 0;
      for (let i = 0; i < children.length; i++) {
        if (children[i] === node) return num;
        if (children[i].nodeType === 1) num += 1;
      }
      return -1;
    },
    setStyle(el, style, val) {
      const setStyle = function (element) {
        element.style[style] = val;
      };
      if (this.isNodeList(el)) {
        this.forEach(el, (i, element) => {
          setStyle(element);
        });
      } else {
        setStyle(el);
      }
    },
    maxSliceHeight(elements, columns) {
      let cIndex = 0;
      // convert the nodelist to an array to allow slicing later
      const elementsArray = [...elements];

      this.setStyle(elements, 'height', '');

      if (elementsArray.length === 0 || !columns) return;

      while (cIndex < elementsArray.length) {
        let cMaxHeight = 0;
        let cColumn;
        for (cColumn = 0; cColumn < columns; cColumn++) {
          const cElem = elementsArray[cIndex + cColumn];
          if (cElem === undefined) break;
          cMaxHeight = cElem.offsetHeight > cMaxHeight ? cElem.offsetHeight : cMaxHeight;
        }

        if (cMaxHeight > 0) {
          const set = elementsArray.slice(cIndex, cIndex + columns);
          for (let i = 0; i < set.length; i++) {
            this.setStyle(set[i], 'height', `${cMaxHeight}px`);
          }
        }

        cIndex += columns;
      }
    },
    prefixedEvent(element, type, callback) {
      const pfx = ['webkit', 'moz', 'MS', 'o', ''];
      let eType = type;
      for (let p = 0; p < pfx.length; p++) {
        if (!pfx[p]) eType = eType.toLowerCase();
        element.addEventListener(pfx[p] + eType, callback, false);
      }
    },
    wrap(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
    isEditMode() {
      return document.querySelector('.page-editor-mode') !== null;
    },
    supportsAnimation() {
      const b = document.body || document.documentElement;
      const s = b.style;
      let p = 'animation';
      if (typeof s[p] === 'string') {
        return true;
      }

      // Tests for vendor specific prop
      const v = ['Moz', 'Webkit', 'Khtml', 'O', 'ms'];
      p = p.charAt(0).toUpperCase() + p.substr(1);
      for (let i = 0; i < v.length; i++) {
        if (typeof s[v[i] + p] === 'string') {
          return true;
        }
      }
      return false;
    },
    supportsTransitions() {
      const b = document.body || document.documentElement;
      const s = b.style;
      let p = 'transition';
      if (typeof s[p] === 'string') {
        return true;
      }

      // Tests for vendor specific prop
      const v = ['Moz', 'Webkit', 'Khtml', 'O', 'ms'];
      p = p.charAt(0).toUpperCase() + p.substr(1);
      for (let i = 0; i < v.length; i++) {
        if (typeof s[v[i] + p] === 'string') {
          return true;
        }
      }
      return false;
    },
  };
})();
